import { render, staticRenderFns } from "./work-order-list-settings-modal.vue?vue&type=template&id=15681a10&scoped=true"
import script from "./work-order-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./work-order-list-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./work-order-list-settings-modal.vue?vue&type=style&index=0&id=15681a10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15681a10",
  null
  
)

export default component.exports